import axios from 'axios';
import http from 'core/services/http';
import Config from 'core/config';


class RequestUpdateService {
  static getRequestUpdate(tcId, testingEventId) {
    return http.get(`${Config.apiUrl}/updaterequest/testcenter/${tcId}/testingevent/${testingEventId}`);
  }

  static updateRequest(data) {
    return http.put(`${Config.apiUrl}/updaterequest`, data);
  }

  static createRequest(data) {
    return http.post(`${Config.apiUrl}/updaterequest`, data);
  }
}

export default RequestUpdateService;
